export default "__VITE_ASSET__e9b2f49e__"